import "./pitch.css";
import type { ReactNode } from "react";

export interface PitchTileProps {
  title: string;
  /** Small caps line above the title. */
  label?: string;
  /** Icon or drawing placed beside the title. */
  icon?: ReactNode;
  tone?: "plain" | "accent" | undefined;
  className?: string | undefined;
  children?: ReactNode;
}

/** The deck tile: rounded panel, title, body slot, optional label. */
export function PitchTile({
  title,
  label,
  icon,
  tone = "plain",
  className,
  children,
}: PitchTileProps) {
  return (
    <div className={`pitch pitch-tile${className ? ` ${className}` : ""}`} data-tone={tone}>
      {label ? <p className="pitch-eyebrow">{label}</p> : null}
      <div className="pitch-tile-head">
        {icon}
        <h3 className="pitch-title">{title}</h3>
      </div>
      {children ? <div className="pitch-text">{children}</div> : null}
    </div>
  );
}
